import React, { useState, useEffect } from "react";
import styles from "../../../styles/CompanyManagement/CompanyDetails.module.css";
import { FiEdit3 } from "react-icons/fi";
import axiosInstance from "../../../utils/api";

const fields = [
  { label: "Company name", name: "name", type: "text" },
  { label: "Company website", name: "website", type: "text" },
  { label: "Company type", name: "companyType", type: "text", dynamic: true },
  { label: "Brand category", name: "brandCategory", type: "text", dynamic: true },
  { label: "About the brand", name: "aboutBrand", type: "textarea", dynamic: true },
];

const Details = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [notFound, setNotFound] = useState(false);
  const [companyId, setCompanyId] = useState(null);

  useEffect(() => {
    axiosInstance.get(`/api/v1/companies`)
      .then(res => {
        const companies = res.data;
        if (companies && companies.length > 0) {
          const data = companies[0];
          setCompanyId(data.id);
          const companyDetails = data.additional_infos?.company_details || {};
          setFormData({
            name: data.name || "",
            website: data.website || "",
            companyType: companyDetails.company_type || "",
            brandCategory: companyDetails.brand_category || "",
            aboutBrand: companyDetails.about_the_brand || ""
          });
          setNotFound(false);
        } else {
          setNotFound(true);
          setFormData({});
          setIsEditing(true);
        }
      })
      .catch(() => {
        setNotFound(true);
        setFormData({});
        setIsEditing(true);
      });
  }, []);

  const handleEditClick = () => setIsEditing(true);
  const handleSaveClick = async () => {
    const staticFields = { name: formData.name, website: formData.website };
    
    // Build company_details object for dynamic fields
    const company_details = {};
    fields.forEach(f => {
      if (f.dynamic) {
        // Map field names to the structure shown in example
        if (f.name === "companyType") company_details.company_type = formData[f.name] || "";
        else if (f.name === "brandCategory") company_details.brand_category = formData[f.name] || "";
        else if (f.name === "aboutBrand") company_details.about_the_brand = formData[f.name] || "";
        else company_details[f.name] = formData[f.name] || "";
      }
    });

    if (notFound) {
      // Create new company
      const payload = { 
        company: { 
          ...staticFields, 
          additional_infos: {
            company_details
          }
        } 
      };
      const res = await axiosInstance.post(`/api/v1/companies`, payload);
      setIsEditing(false);
      setNotFound(false);
      if (res.data && res.data.id) setCompanyId(res.data.id);
    } else {
      // Update existing company - merge with existing additional_infos
      const res = await axiosInstance.get(`/api/v1/companies/${companyId}`);
      const existing = res.data.additional_infos || {};
      const payload = { 
        company: { 
          ...staticFields, 
          additional_infos: {
            ...existing,
            company_details
          }
        } 
      };
      await axiosInstance.patch(`/api/v1/companies/${companyId}`, payload);
      setIsEditing(false);
    }
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  if (notFound) {
    return (
      <div>
        <div className={styles.detailsHeader}>
          <span className={styles.detailsHeading}>Create Company</span>
        </div>
        <div className={styles.separator} />
        <div className={styles.detailsContent}>
          {fields.map((field) => (
            <div className={styles.detailItem} key={field.name}>
              <span className={styles.detailLabel}>{field.label}</span>
              {field.type === "textarea" ? (
                <textarea
                  name={field.name}
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                />
              ) : (
                <input
                  type={field.type}
                  name={field.name}
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                />
              )}
            </div>
          ))}
          <button className={styles.saveBtn} onClick={handleSaveClick}>
            Save
          </button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className={styles.detailsHeader}>
        <span className={styles.detailsHeading}>Details</span>
        {!isEditing ? (
          <button className={styles.editBtn} onClick={handleEditClick}>
            <FiEdit3 /> Edit
          </button>
        ) : (
          <button className={styles.saveBtn} onClick={handleSaveClick}>
            Save
          </button>
        )}
      </div>
      <div className={styles.separator} />
      <div className={styles.detailsContent}>
        {fields.map((field) => (
          <div className={styles.detailItem} key={field.name}>
            <span className={styles.detailLabel}>{field.label}</span>
            {isEditing ? (
              field.type === "textarea" ? (
                <textarea
                  name={field.name}
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                />
              ) : (
                <input
                  type={field.type}
                  name={field.name}
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                />
              )
            ) : (
              <p>{formData[field.name]}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Details;
